module.exports = __webpack_public_path__ + "static/media/uw_madison_flag.0e18785f.png";